module.exports = __webpack_public_path__ + "static/media/Live Chat.f680493c.webp";